'use client'

import Link from 'next/link'

export function EveLogo({ width = 130 }) {
  return (
    <Link href="/">
      <svg
        width={width}
        fill="#fff"
        height="100%"
        viewBox="0 0 130 55"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <path
          fill="#fff"
          d="M0 20.801h39.76v-7.038H0v7.038Zm0-10.616h7.187V7.769h32.572V.725H0v9.46Zm7.187 14.163H0v9.485h39.76v-7.04H7.187v-2.445Zm90.234 0h-7.184v9.485h39.757v-7.04H97.418c.003-.66.003-2.445.003-2.445Zm-32.415 1.69L50.944.724h-7.817l21.88 39.581L86.87.725h-7.824s-13.19 23.777-14.04 25.312ZM90.24.724v9.46h7.184V7.769H130V.725H90.24Zm0 20.076h39.757v-7.038H90.24v7.038ZM26.18 49.617c0-.549.099-.925.3-1.13.197-.203.58-.305 1.149-.305h4.291c.572 0 .958.1 1.16.305.197.202.299.578.299 1.13v3.213c0 .559-.102.938-.3 1.137-.2.202-.587.305-1.159.305h-4.288c-.572 0-.952-.1-1.15-.305-.2-.2-.3-.578-.3-1.137v-3.212h-.002Zm1.362 3.508h4.477v-3.858h-4.477v3.858ZM42.18 54.27v-6.085h.93l4.125 3.589c.139.122.265.23.37.334.109.109.207.215.297.324a45.809 45.809 0 0 1-.043-.723c-.006-.144-.013-.253-.013-.33v-3.194h1.22v6.088h-.93l-4.3-3.762a9.027 9.027 0 0 1-.272-.26 3.1 3.1 0 0 1-.216-.238c.018.19.03.367.043.534.006.167.01.311.01.433v3.29H42.18ZM57.992 54.27v-6.085h1.363v4.941h4.39v1.144h-5.753ZM71.68 54.27v-6.085h1.362v6.088H71.68v-.004ZM81.96 54.27v-6.085h.934l4.125 3.589c.142.122.266.23.374.334.108.109.207.215.293.324a44.271 44.271 0 0 1-.043-.723 5.276 5.276 0 0 1-.012-.33v-3.194h1.217v6.088h-.93l-4.3-3.762c-.106-.096-.196-.183-.276-.26a3.037 3.037 0 0 1-.213-.238c.018.19.034.367.04.534.012.167.016.311.016.433v3.29H81.96ZM97.773 54.27v-6.085h5.988v1.038h-4.622v1.356h2.691v1.037h-2.69v1.507h4.677v1.143h-6.044v.004Z"
        ></path>
      </svg>
    </Link>
  )
}
